import { Component, Input} from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { Router} from '@angular/router';
import { ApplicationProcessApi } from '../../../@core/backend/common/api/applicationProcess.api';
import {  NbToastrService } from '@nebular/theme';
import { NbAuthJWTToken, NbAuthService } from '@nebular/auth';

@Component({
    selector: 'nb-dialog-pdf',
    templateUrl: './documentViewer.component.html',
    styleUrls: ['./documentViewer.component.scss'],
    })
export class DocumentViewer {
    @Input() arr: any;
    @Input() srcInp: any;
    @Input() user_id: any;
    @Input() type: any;
    fileDetails: any;
    constructor(protected ref: NbDialogRef<DocumentViewer>,
      private router : Router,
      private authService: NbAuthService,
      private processApi : ApplicationProcessApi,
      private toastrService: NbToastrService,
      ) {}

      ngOnInit()
      {
            this.processApi.getFileDetails(this.arr,this.user_id,this.type).subscribe(data=>{
                if(data['status'] == 200){
                    this.fileDetails = data['data'];
                }
            })
           
      }
    
    close(){
        this.ref.close();
    }   
}